module.exports = __webpack_public_path__ + "static/media/chatter.559923d4.svg";